import { AdminApiError } from './api-client.js';
import type { AutosaveConflict } from './autosave.js';

export function readRevisionConflict<Value>(
  error: unknown,
  select: (current: unknown) => Value | null,
): AutosaveConflict<Value> | null {
  if (!(error instanceof AdminApiError) || error.code !== 'REVISION_CONFLICT') return null;
  const payload = error.payload;
  if (!payload || typeof payload !== 'object') return null;
  const envelope = payload as {
    error?: { current?: unknown; currentRevision?: unknown };
  };
  const value = select(envelope.error?.current);
  const revision = envelope.error?.currentRevision;
  if (value === null || typeof revision !== 'number') return null;
  return { serverValue: value, serverRevision: revision };
}
